module.exports = __webpack_public_path__ + "img/pay-logo-alipay.ffe05bc8.jpg";